<div
  class="ea-progress"
  [ngStyle]="{ width: maxWidth ? maxWidth : '100%', height: height }"
  [ngClass]="{
    'ea-progress-sm': size == 'small',
    'ea-progress-md': size == 'medium',
  }"
>
  <div
    class="progress-bg"
    [ngStyle]="{ background: bgColor ? bgColor : color }"
    [ngClass]="{ rounded: rounded }"
  ></div>
  <div
    class="progress-bar"
    [ngStyle]="{
      width: (progress > 3 ? progress : 3) + '%',
      background: color,
    }"
    [ngClass]="{ rounded: rounded }"
  >
    @if (displayText) {
      <span>{{ progress < maxWidth ? progress : maxWidth }}%</span>
    }
  </div>
</div>
